// 面接モードの「質問数」の単一ソース。
// 面接モード設定画面（InterviewSetupClient）と使い方ページ（/how-to-use）が
// このモジュールを共有し、表示される問数がズレないようにする。
//
// 深掘り質問は「固定質問1問につき最大1問」出題される。
// したがって1セッションの合計問数の上限は、固定質問数の2倍になる。

/** 面接モードで選べる固定質問数。 */
export const INTERVIEW_QUESTION_COUNT_OPTIONS = [1, 2, 3] as const;

export type InterviewQuestionCount =
  (typeof INTERVIEW_QUESTION_COUNT_OPTIONS)[number];

/** 設定画面で「おすすめ」として推奨する固定質問数。 */
export const RECOMMENDED_INTERVIEW_QUESTION_COUNT: InterviewQuestionCount = 2;

/** 固定質問1問につき出題される深掘り質問の上限。 */
export const MAX_FOLLOW_UP_PER_QUESTION = 1;

export const INTERVIEW_QUESTION_COUNT_MIN = Math.min(
  ...INTERVIEW_QUESTION_COUNT_OPTIONS,
);
export const INTERVIEW_QUESTION_COUNT_MAX = Math.max(
  ...INTERVIEW_QUESTION_COUNT_OPTIONS,
);

/** 固定質問数の範囲（例: 「1〜3問」）。 */
export const INTERVIEW_FIXED_QUESTION_RANGE_LABEL = `${INTERVIEW_QUESTION_COUNT_MIN}〜${INTERVIEW_QUESTION_COUNT_MAX}問`;

/** 深掘りを含めた合計問数の範囲（例: 「2〜6問」）。 */
export const INTERVIEW_TOTAL_QUESTION_RANGE_LABEL = `${
  INTERVIEW_QUESTION_COUNT_MIN * (1 + MAX_FOLLOW_UP_PER_QUESTION)
}〜${INTERVIEW_QUESTION_COUNT_MAX * (1 + MAX_FOLLOW_UP_PER_QUESTION)}問`;
